module.exports = "/images/success-icon.svg?422ba4b57cd708b85b56a255ba3802f5";